import {useEffect} from 'react';

import helpers from '../utils/helpers';

const useScrollTop = (deps = []) => {
    useEffect(() => {
        helpers.scrollTop();
    }, deps);
};

export default useScrollTop;
